module.exports = __webpack_public_path__ + "cbf6499722701b38d8b31e3c64752a32.png";